import { useState, useEffect } from "react";

const useContrastRatio = (firstColor, secondColor) => {
  const [ratio, setRatio] = useState([1.05, 0.1])

  const hexToRGB = (hex) => {
    try {
      hex = hex.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)

      return [
        isNaN(r) ? 0 : r,
        isNaN(g) ? 0 : g,
        isNaN(b) ? 0 : b
      ]
    } catch (err) {
      return [0, 0, 0]
    }
  }

  const relativeLuminance = (r,g,b) => {
    const transform = (v) => {
      v /= 255
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055)/1.055 , 2.4)
    }
    const R = transform(r)
    const G = transform(g)
    const B = transform(b)

    return (0.2126 * R + 0.7152 * G + 0.0722 * B)
  }

  useEffect(() => {
    if (!firstColor || !secondColor) {
      return
    }

    const first = hexToRGB(firstColor)
    const second = hexToRGB(secondColor)

    const L1 = relativeLuminance(...first)
    const L2 = relativeLuminance(...second)

    let ratio1 = 1
    let ratio2 = 1

    if (L1 > L2) {
      ratio1 = L1 + 0.05
      ratio2 = L2 + 0.05
    } else {
      ratio1 = L2 + 0.05
      ratio2 = L1 + 0.05
    }
    setRatio([Number(ratio1.toFixed(2)), Number(ratio2.toFixed(2))])

  }, [firstColor, secondColor])

  return ratio
}

export default useContrastRatio